<template>
    <Loading
        :is-loading="isLoading"
        :text="processingText"
    />
    <PersonalInformation
        :visible="visible"
        :source="'SSO'"
        :token="tokenString"
        @clickBtn="agreePersonalInformation"
    />
    <Popup v-model:visiblePopup="baVisiblePopup">
        <template #title>
            約定指定聯絡人
        </template>
        <template #content>
            您的保單尚未約定「指定聯絡人」，若您同意本次交易同時約定，請點選『約定』後，勾選變更項目【指定聯絡人作業】一併辦理。
        </template>
        <template #action>
            <div class="flex flex-col w-full mb-2">
                <Checkbox
                    v-model:checkedValues="noShowBAPopup"
                    :value="true"
                    class="mb-2"
                    text="不要再詢問我"
                />
            </div>
            <button
                class="btn btn-accent rounded-full"
                @click="baClick(false)"
            >
                不約定
            </button>
            <button
                class="btn  gradient-primary rounded-full"
                @click="baClick(true)"
            >
                約定
            </button>
        </template>
    </Popup>
</template>
<script>
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { postSSOLogin } from '@/apis/login';
import { ssoInitTransaction } from '@/apis/system';
import Loading from '@/components/Loading.vue';
import routeName from '@/router/constant.js';
import serviceRoutes from '@/json/serviceRoutes'; // serviceRoutes 按鈕JSON
import aplCatlCode from '@/json/aplCatlCode';
import codeList from '@/json/codeList';
import PersonalInformation from '@/components/dialogs/PersonalInformation.vue';
import { postNeedPersonalInformation } from '@/apis/agreeTerms';
import Checkbox from '@/components/checkboxs/Checkbox.vue';
import Popup from '@/components/dialogs/Popup.vue';

export default {
    components: {
        Popup,
        Checkbox,
        Loading,
        PersonalInformation,
    },
    setup() {
        const route = useRoute();
        const router = useRouter();
        const store = useStore();
        const isLoading = ref(true);
        const processingText = ref('登入檢核中...');
        const visible = ref(false);
        const tokenString = ref('');
        const needBa = ref(false);
        const baVisiblePopup = ref(false);
        const noShowBAPopup = ref(false);
        const toBa = ref(false);
        const baPopupItem = 'BaSsoPopup';
        // 手機e方便或是SCV SSO 登入
        const ssoLogin = (data) => {
            return postSSOLogin(data).then((res) => {
                store.dispatch('services/resetService');
                store.dispatch('policy/resetPolicy');

                store.dispatch('permissions/setAuth', 'Y');
                store.dispatch('permissions/setUserInfo', res.data);
                processingText.value = '處理中...';
                return res.data.ssoToken;
            });
        };

        // 所有可進行的變更項目按鈕資訊
        const btnJSON = ref(JSON.parse(JSON.stringify(serviceRoutes)));

        const baClick = (v) => {
            if (noShowBAPopup.value) {
                localStorage.setItem(baPopupItem, 'Y');
            }
            toBa.value = v;
            goLogin();
        };

        // 初始化交易，並轉導至指定頁面
        const initTransaction = (data) => {
            return ssoInitTransaction(data)
                .then(res => res.data)
                .then(data => {
                    // 設定原本1~5步驟的 vuex store
                    // 1. 初始化交易物件
                    store.dispatch('services/setAplCatl', data.aplCatl);
                    store.dispatch('permissions/setTransactionId', data.transactionUniqueId);

                    if (data.aplCatl === aplCatlCode.PON4300) {
                        // 如果是進行保單借款，則不需要設定2~5步驟的 vuex store
                        const mappingBtn = btnJSON.value.find((btn) => btn.code === 'Pon4300');
                        const serviceData = [{
                            transactionItemName: '保單借款',
                            userChecked: true,
                            transactionItemNo: mappingBtn.code,
                            routeName: mappingBtn.routeName,
                        }];
                        store.dispatch('services/setServices', serviceData);
                        store.dispatch('services/setTransactionItems', serviceData);
                        return {
                            routerName: data.routerName,
                            aplCatl: aplCatlCode.PON4300,
                            params: data.params,
                        };
                    } else if (data.aplCatl === aplCatlCode.MULTI_ENOTIFY) {
                        // 如果是進行申請電子通知單(要保人)，則不需要設定2~5步驟的 vuex store
                        const mappingBtn = btnJSON.value.find((btn) => btn.code === 'multiENotify');
                        const serviceData = [{
                            transactionItemName: '申請電子通知單',
                            userChecked: true,
                            transactionItemNo: mappingBtn.code,
                            routeName: mappingBtn.routeName,
                        }];
                        store.dispatch('services/setServices', serviceData);
                        store.dispatch('services/setTransactionItems', serviceData);
                        return {
                            routerName: data.routerName,
                            aplCatl: aplCatlCode.MULTI_ENOTIFY,
                            params: data.params,
                        };
                    } else if (data.aplCatl === aplCatlCode.CONTACT) {
                        // 如果是進行多張地址電話Email變更，則不需要設定2~5步驟的 vuex store
                        const mappingBtn = btnJSON.value.find((btn) => btn.code === 'BD');
                        const serviceData = [{
                            transactionItemName: '要保人聯絡資料',
                            userChecked: true,
                            transactionItemNo: mappingBtn.code,
                            routeName: mappingBtn.routeName,
                        }];
                        store.dispatch('services/setServices', serviceData);
                        store.dispatch('services/setTransactionItems', serviceData);
                        return {
                            routerName: data.routerName,
                            aplCatl: aplCatlCode.CONTACT,
                            params: data.params,
                        };
                    } else if (data.aplCatl === aplCatlCode.MULTI_PAY_CHANGE ||
                        data.aplCatl === aplCatlCode.ACH ||
                        data.aplCatl === aplCatlCode.CREDIT_CARD_EXP) {
                        // 指定進入變更項目中
                        if (data.routerName === routeName.EDIT_TEL_MAIL || data.routerName === routeName.AUTH_METHODS) {
                            let code = '';
                            let title = '';

                            if (data.aplCatl === aplCatlCode.MULTI_PAY_CHANGE) {
                                code = codeList.MULTI_PAY_CHANGE;
                                title = '申請自行繳費';
                            } else if (data.aplCatl === aplCatlCode.CREDIT_CARD_EXP) {
                                code = codeList.CREDIT_CARD_EXP;
                                title = '信用卡效期延長';
                            } else {
                                code = codeList.ACH;
                                title = '申請金融機構轉帳電子化繳費授權';
                            }
                            const mappingBtn = btnJSON.value.find((btn) => btn.code === code);
                            const index = serviceRoutes.findIndex(i => i.code === mappingBtn.code);
                            const serviceData = [{
                                transactionItemName: title,
                                userChecked: true,
                                transactionItemNo: mappingBtn.code,
                                routeName: serviceRoutes[index].routeName,
                            }];

                            store.dispatch('services/setServices', serviceData);
                            store.dispatch('services/setTransactionItems', serviceData);
                            return {
                                routerName: data.routerName,
                                aplCatl: data.aplCatl,
                                params: data.params,
                            };
                        }

                        // 如果是進行保費相關的變更項目，如：申請自行繳費、信用卡效期延長、申請金融機構轉帳電子化繳費授權
                        // 也不需要設定2~5步驟的 vuex store，直接轉到指定的畫面
                        return {
                            routerName: data.routerName,
                            aplCatl: data.aplCatl,
                            params: data.params,
                        };
                    }

                    // 2. 保單總覽
                    // 導向傳統型保單或投資型保單
                    if (!data.selectedPolicy) {
                        return {
                            routerName: data.routerName,
                            aplCatl: data.aplCatl,
                            params: data.params,
                        };
                    }
                    // 3. 選擇要進行變更的保單
                    // 如果是投資型的保單，investTypeText就會是投資屬性對應的文字或是空字串
                    // 如果是傳統型的保單，investTypeText就會是undefined或null
                    if (data.selectedPolicy) {
                        if (data.selectedPolicy.investTypeText !== undefined && data.selectedPolicy.investTypeText !== null) {
                            store.dispatch('policy/setPolicyKindInvestment', 'Y');
                        }
                        store.dispatch('policy/setPolicy', data.selectedPolicy);
                    }
                    // 4. 取得可以進行的交易變更項目
                    const menuItems = data.menuItems.map((menuItem) => {
                        const mappingBtn = btnJSON.value.find((btn) => btn.code === menuItem.transactionItemNo);
                        const hasNo = data.selectedMenuItems ? data.selectedMenuItems.find(k => k.transactionItemNo === menuItem.transactionItemNo) : false;
                        menuItem.userChecked = hasNo ? true : (menuItem.select || menuItem.forceSelect);
                        menuItem.confirm = false;
                        menuItem.routeName = mappingBtn.routeName;
                        return menuItem;
                    });

                    store.dispatch('services/setTransactionItems', menuItems);

                    // 5. 選擇要進行的交易變更項目
                    // 如果沒有選擇變更項目，就直接轉導至指定頁面，不需要設定 store
                    const serviceList = data.selectedMenuItems;
                    if (!serviceList || serviceList.length === 0) {
                        return {
                            routerName: data.routerName,
                            aplCatl: data.aplCatl,
                            params: data.params,
                        };
                    }
                    const services = serviceList.map((service) => {
                        const obj = menuItems.find(menuItme => service.transactionItemNo === menuItme.transactionItemNo);
                        service.routeName = obj.routeName;
                        service.confirm = obj.confirm;
                        return service;
                    });
                    store.dispatch('services/setServices', services);
                    return {
                        routerName: data.routerName,
                        aplCatl: data.aplCatl,
                        params: data.params,
                    };
                }).catch(ex => {
                    return {
                        routerName: ex?.routerName,
                        aplCatl: ex?.aplCatl,
                        params: ex?.params,
                    };
                });
        };

        // GET url 當中的參數 param，就是 SSO token
        const token = {
            token: route.query.param,
        };

        tokenString.value = token.token;

        const getParamsVariable = function (params, variable) {
            if (!params) {
                return '';
            }
            const vars = params.split('&');
            for (let i = 0; i < vars.length; i++) {
                const pair = vars[i].split('=');
                if (decodeURIComponent(pair[0]) === variable) {
                    return decodeURIComponent(pair[1]);
                }
            }
            return '';
        };

        const goLogin = () => {
            baVisiblePopup.value = false;
            // 開始登入
            ssoLogin(token)
                .then(data => {
                    if (data.aplCatl) {
                        // 如果產生的 sso token 資訊當中有包含交易類型，就會開始初始化交易
                        if (toBa.value) {
                            data.aplCatl = '640';
                            data.transactionItemNo = 'BA';
                        }
                        return initTransaction(data);
                    } else if (data.system && data.system === 'CEC') {
                        return { routerName: routeName.CLOUD_E_COUNTER_HOME };
                    } else {
                        // 如果產生的 sso token 資訊當中沒有包含交易類型，就直接進入線上交易首頁
                        return { routerName: routeName.HOME };
                    }
                })
                .then(result => {
                    const routerName = result?.routerName;
                    const aplCatl = result?.aplCatl;
                    const params = result?.params;

                    if (aplCatl === aplCatlCode.MULTI_PAY_CHANGE ||
                        aplCatl === aplCatlCode.ACH ||
                        aplCatl === aplCatlCode.CREDIT_CARD_EXP) {
                        router.push({
                            name: routerName,
                            params: { action: getParamsVariable(params, 'action') },
                        });
                    } else if (routerName) {
                        router.push({ name: routerName });
                    } else {
                        router.push({ name: routeName.HOME });
                    }
                })
                .catch((ex) => {
                    router.push({
                        name: routeName.FORBIDDEN,
                        params: { errorMessage: ex.data.errorMessage },
                    });
                })
                .finally(() => {
                    isLoading.value = false;
                });
        };

        const agreePersonalInformation = () => {
            visible.value = false;
            if (needBa.value && localStorage.getItem(baPopupItem) !== 'Y') {
                baVisiblePopup.value = true;
            } else {
                goLogin();
            }
        };

        const initCheck = () => {
            const request = {
                token: tokenString.value,
            };
            postNeedPersonalInformation(request).then((res) => {
                needBa.value = res.data?.needBa;
                if (res.data.needPersonalInformation) {
                    visible.value = true;
                } else {
                    agreePersonalInformation();
                }
            }).catch((ex) => {
                router.push({
                    name: routeName.FORBIDDEN,
                    params: { errorMessage: ex.data.errorMessage },
                });
            });
        };

        initCheck();

        return {
            isLoading,
            processingText,
            agreePersonalInformation,
            visible,
            tokenString,
            noShowBAPopup,
            baVisiblePopup,
            baClick,
        };
    },
};
</script>
